import { css } from '@emotion/react';

export const chartWrapperStyles = css`
  width: 100%;
  min-width: 0;
  color: var(--text-primary);
`;

export const chartHeaderStyles = css`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  margin-bottom: var(--spacing-3);
`;

export const chartSurfaceStyles = css`
  display: flex;
  flex-direction: column;
  width: 100%;

  .recharts-cartesian-axis-tick-value {
    fill: var(--text-secondary);
    font-size: 12px;
  }

  .recharts-legend-wrapper {
    color: var(--text-secondary);
    font-size: 12px;
    line-height: 16px;
  }
`;

export const chartCanvasStyles = css`
  width: 100%;
  min-height: 0;
  flex: 1 1 auto;
`;

export const compactYAxisLabelStyles = css`
  flex: 0 0 auto;
  margin: 0 0 var(--spacing-1);
  color: var(--text-secondary);
  font-size: 12px;
  line-height: 16px;
`;

export const emptyStateStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 180px;
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-lg);
  background-color: var(--surface-neutral);
  color: var(--text-secondary);
  font-size: 14px;
  line-height: 20px;
`;

export const tooltipStyles = css`
  min-width: 140px;
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-tooltip);
  background-color: var(--surface-page);
  padding: var(--spacing-3);
  color: var(--text-primary);
`;

export const tooltipLabelStyles = css`
  margin: 0 0 var(--spacing-2);
  color: var(--text-secondary);
  font-size: 12px;
  line-height: 16px;
`;

export const tooltipRowStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-4);
  margin: var(--spacing-1) 0 0;
  font-size: 13px;
  line-height: 18px;
`;

export const tooltipSeriesStyles = css`
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-2);
  min-width: 0;
`;

export const tooltipSwatchStyles = css`
  width: 8px;
  height: 8px;
  border-radius: var(--radius-round);
  flex: 0 0 auto;
`;
